import {
  ArrowPathIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/solid';
import {
  type OnboardImportStatusType,
  OnboardImportStatusTypeEnum,
} from '../../types/onboard-import.type.ts';

export const OnboardImportStatusIndicator = ({ status }: { status: OnboardImportStatusType }) => {
  switch (status?.id) {
    case OnboardImportStatusTypeEnum.InProgress:
      return <ArrowPathIcon title='In progress' className='text-primary-500 size-8 animate-spin' />;
    case OnboardImportStatusTypeEnum.Success:
      return <CheckCircleIcon title='Success' className='text-green-500 size-8' />;
    case OnboardImportStatusTypeEnum.Error:
      return <ExclamationCircleIcon title='Error' className='text-red-500 size-8' />;
    case OnboardImportStatusTypeEnum.Warning:
      return <ExclamationTriangleIcon title='Warning' className='text-yellow-500 size-8' />;
    case OnboardImportStatusTypeEnum.Information:
      return <InformationCircleIcon title='Information' className='text-gray-500 size-8' />;
    default:
      return null;
  }
};
